export default {
  home: 'Home',
  game: 'Game',
  deposit: 'Deposit',
  activity: 'Activity',
  mine: 'Mine',
};
